import { IExponentialBackOffOptions } from '../interface/types'
import { AlwaysDelay } from './alwaysDelay/alwaysDelay'
import { SkipFirstDelay } from './skipFirst/skipFirstDelay'
import { IDelay } from './types'

export const DelayFactory = (
  options: IExponentialBackOffOptions,
  attempt: number,
): IDelay => {
  const delay = initDelayClass(options)
  delay.setAttemptNumber(attempt)
  return delay
}

const initDelayClass = (options: IExponentialBackOffOptions) => {
  if (!options.isFirstAttepmtDelayed) {
    return new SkipFirstDelay(options)
  }

  return new AlwaysDelay(options)
}
